import styled, { css } from 'styled-components';
import { breakpoints, colors, font, spacing } from '@chegg-ui/theme';
import { Accordion } from '@chegg-ui/accordion';
import { Tag } from '@chegg-ui/tag';
import { Checkbox } from '@chegg-ui/checkbox';
export var AddPaymentMethodButton = styled.button.withConfig({
  componentId: "sc-15r863c-0"
})(["cursor:pointer;flex-grow:1;border:1.5px solid #cdcdd4;min-height:", ";padding:16px 10px;border-radius:16px;background-color:", ";&:hover{background-color:", ";}svg{padding-right:10px;}.add-payment-method-description{font-size:", ";}"], spacing.px48, colors.white, colors.grey100, font.size.px18);
export var AddPaymentMethodButtonContainer = styled.div.withConfig({
  componentId: "sc-15r863c-1"
})(["display:flex;align-items:center;flex-direction:row;margin:16px 0px;"]);
export var BackupDetails = styled.div.withConfig({
  componentId: "sc-15r863c-2"
})(["padding-left:46px;font-size:", ";", " @media (max-width:", "){width:257px;}"], font.size.px12, function (_ref) {
  var isDisabled = _ref.isDisabled;
  return isDisabled && "\n      color: ".concat(colors.grey500, ";\n  ");
}, breakpoints.sm.max);
export var CardDescription = styled.span.withConfig({
  componentId: "sc-15r863c-3"
})(["display:flex;flex-direction:row;font-family:", ";margin-left:10px;white-space:normal;overflow:hidden;text-overflow:ellipsis;.card-info{font-size:", ";font-weight:", ";margin-right:", ";}.exp-date{color:", ";font-size:", ";font-weight:", ";}span{display:flex;align-items:center;}@media screen and (min-width:", "){flex-direction:column;max-width:200px;}"], font.family.aspira, font.size.px18, font.weight.bold, spacing.px8, colors.grey700, font.size.px14, font.weight.normal, breakpoints.lg.min);
export var CountryFlagSVG = styled.svg.withConfig({
  componentId: "sc-15r863c-4"
})(["width:28px;height:22px;flex-basis:14.48%;padding:0;"]);
export var CountryFlagImage = styled.image.withConfig({
  componentId: "sc-15r863c-5"
})(["width:28px;height:22px;"]);
export var CountryName = styled.div.withConfig({
  componentId: "sc-15r863c-6"
})(["padding:0 16px;width:100%;"]);
export var ExpDateSlash = styled.div.withConfig({
  componentId: "sc-15r863c-7"
})(["color:", ";padding:14px 16px;"], colors.grey500);
export var FormColumnWrapper = styled.div.withConfig({
  componentId: "sc-15r863c-8"
})(["display:flex;flex-direction:row;@media (max-width:", "){flex-direction:column;.expiration-date{flex-direction:row;}}"], breakpoints.sm.max);
export var FormInput = styled.div.withConfig({
  componentId: "sc-15r863c-9"
})(["display:flex;align-items:center;justify-content:flex-start;border-radius:4px;background-color:", ";color:", ";width:100%;height:", ";padding:", ";#icon-story-Caret{padding:0;}"], colors.grey200, colors.grey500, spacing.px48, spacing.px16);
export var FormInputHeader = styled.div.withConfig({
  componentId: "sc-15r863c-10"
})(["color:", ";font-size:0.875rem;font-weight:bold;padding-bottom:", ";height:1.637rem;"], colors.grey500, spacing.px8);
export var FormRowWrapper = styled.div.withConfig({
  componentId: "sc-15r863c-11"
})(["display:flex;flex-direction:column;flex-basis:100%;padding:0 12px 16px;"]);
export var ListItem = styled.li.withConfig({
  componentId: "sc-15r863c-12"
})(["cursor:pointer;display:flex;flex-direction:row;justify-content:space-between;padding:24px 0px;div:first-child{padding-left:2px;}svg + div{display:inline-block;width:calc(100% - 20px);}data-test > div,label{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;padding-right:10px;}"]);
export var MopActionSection = styled.div.withConfig({
  componentId: "sc-15r863c-13"
})(["text-align:right;width:100%;flex-direction:row;align-items:center;justify-content:flex-end;padding:48px 12px 0px;.mop-details-update-button{padding:0px 22px;}@media (max-width:", "){display:flex;flex-direction:column-reverse;.mop-details-cancel-button{margin-top:", ";}.mop-details-update-button{width:100%;}}"], breakpoints.sm.max, spacing.px16);
export var MopCheckbox = styled.div.withConfig({
  componentId: "sc-15r863c-14"
})(["display:flex;flex-direction:column;width:100%;padding:0 12px;.make-default-checkbox{padding-bottom:24px;}"]);
export var MopCheckboxWrapper = styled(Checkbox).withConfig({
  componentId: "sc-15r863c-15"
})(["> svg{padding-right:0;width:auto;", "}"], function (_ref2) {
  var checked = _ref2.checked,
    disabled = _ref2.disabled;
  return checked && !disabled && "\n      color: ".concat(colors.cheggOrange, ";\n    ");
});
export var MopDetailsContainer = styled.div.withConfig({
  componentId: "sc-15r863c-16"
})(["display:flex;flex-direction:column;align-items:flex-start;justify-content:flex-start;padding:32px 20px;@media (max-width:", "){padding:24px 4px;}"], breakpoints.sm.max);
export var MopDetailsSection = styled.div.withConfig({
  componentId: "sc-15r863c-17"
})(["display:flex;flex-direction:column;width:100%;padding-bottom:32px;"]);
export var MopList = styled.ul.withConfig({
  componentId: "sc-15r863c-18"
})(["display:flex;flex-direction:column;list-style-type:none;margin:0;padding:0;"]);
export var PaddedContainer = styled.div.withConfig({
  componentId: "sc-15r863c-19"
})(["display:flex;align-items:center;padding:10px;"]);
export var StyledAccordion = styled(Accordion).withConfig({
  componentId: "sc-15r863c-20"
})(["button{cursor:pointer;padding:0;min-height:", ";border-width:1.5px;box-shadow:none;&:hover{background-color:", ";@media (max-width:", "){background-color:", ";}}li{flex-grow:1;}}div > h2 > button > div{flex-grow:1;max-width:100%;}#mop-list-accordion-button-", "{", "}#mop-list-accordion-panel-", "{background-color:", ";box-shadow:none;margin-top:53px;padding-top:0px;}svg{padding-right:10px;}"], spacing.px48, colors.grey100, breakpoints.sm.max, colors.white, function (props) {
  return props.selectedMopIndex;
}, function (_ref3) {
  var isSelected = _ref3.isSelected;
  return isSelected && css(["border-color:", ";"], colors.cheggOrange);
}, function (props) {
  return props.selectedMopIndex;
}, colors.grey050);
export var TagBase = styled(Tag).withConfig({
  componentId: "sc-15r863c-21"
})(["position:absolute;right:10px;margin-right:10px;", " & > div:first-child{height:24px;background-color:", ";color:", ";border-radius:12px;padding:0 12px;font-size:", ";display:flex;justify-content:center;align-items:center;box-shadow:none;margin:0;}"], function (_ref4) {
  var isCheckoutPage = _ref4.isCheckoutPage;
  return !isCheckoutPage && "\n      padding-left: 10px;\n      padding-right: 30px;\n    ";
}, function (_ref5) {
  var backgroundColor = _ref5.backgroundColor;
  return backgroundColor || '';
}, colors.grey700, font.size.px14);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/Recurly/MopListView/styled.js
// module id = 500
// module chunks = 11